import type {ChecklistItem} from 'shells/onboarding-checklist/types';

import type {GetInboxDashboardChecklist_inboxDashboardChecklist_items as InboxDashboardChecklistItem} from 'nutshell-graphql-types';

export const getOnboardingChecklistItems = (
    items: InboxDashboardChecklistItem[],
    appHistory: any,
    onOpenEngagementBarOnboardingModal: () => void
): ChecklistItem[] => {
    const checklistItems = [];

    for (const item of items) {
        let onClick = () => {};

        switch (item.key) {
            case 'embedChat':
                if (item.isComplete) {
                    onClick = onOpenEngagementBarOnboardingModal;
                } else {
                    onClick = () => appHistory.push('/inbox/settings/chat-onboarding');
                }
                break;
            case 'reviewAgentsAndAvailability':
                onClick = () => appHistory.push('/inbox/settings/agents');
                break;
            case 'setupSMS':
                onClick = () => appHistory.push('/inbox/settings/sms');
                break;
        }

        checklistItems.push({
            ...item,
            onClick,
        });
    }

    return checklistItems;
};

export const hasEmbeddedChat = (items: ChecklistItem[]): boolean => {
    const checklistItem = items.find((item: ChecklistItem) => item.key === 'embedChat');

    return checklistItem ? checklistItem.isComplete : false;
};

export const hasConfiguredSMS = (items: ChecklistItem[]): boolean => {
    const checklistItem = items.find((item: ChecklistItem) => item.key === 'setupSMS');

    return checklistItem ? checklistItem.isComplete : false;
};
